// app/javascript/controllers/file_download_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        url: String,
        filename: String
    }

    download() {
        // Required to also work on turbo streams
        this.directDownload()
    }
    directDownload() {
        const link = document.createElement('a')
        link.href = this.urlValue
        link.download = this.filenameValue
        link.target = '_blank'
        link.rel = 'noopener noreferrer'

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
}
